var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Timeline',{attrs:{"title":_vm.$t('nav.public_tl'),"timeline":_vm.timeline,"timeline-name":'public'}})}
var staticRenderFns = []
export { render, staticRenderFns }